export enum SubtotalThemes {
  DEFAULT = 'default',
  JOIN_FLOW = 'join-flow',
}
